import { NavBar } from "@finanedi.es/storybook"
import CustomButton from "common/components/Button/Button"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import NavBarChildren from "common/components/NavBar"
import { validateEmail } from "common/utils/formValidations"
import {
  sendResetPasswordConfirmation,
  userSelector,
} from "features/User/redux/slices/userSlice"
import { Form, Formik } from "formik"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import "./recoveryPassword.scss"

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    email: validateEmail(t),
    confirmEmail: Yup.string()
      .required(t("errors.emailEmpty"))
      .oneOf([Yup.ref("email"), null], t("errors.emailsNotSame")),
  })

const initialValues = {
  email: "",
  confirmEmail: "",
}

const RecoveryPasswordStep1 = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { loadingResetPassword } = useSelector(userSelector)

  const onSubmit = ({ email }: $TSMigrationFixMe) => {
    dispatch(sendResetPasswordConfirmation(email))
  }

  return (
    <>
      <NavBar classNameNavBar='!tw-w-full !tw-flex-grow-0 tw-shadow-md tw-min-h-5 tw-h-16 tw-flex tw-items-center tw-p-0.5 tw-z-0 tw-bg-primary tw-order-last'>
        <NavBarChildren
          secondary
          hideRegis
        />
      </NavBar>
      <div className='container text-left form-recovery-password'>
        <h5>{t("recoveryPassword.title")}</h5>

        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema(t)}
        >
          <Form className='p-fluid'>
            <div className='mt-4 p-field'>
              <label htmlFor='email'>{t("recoveryPassword.labelMail")}</label>
              <FormikInputText
                autoFocus
                name='email'
                id='email'
                noSpaces
              />
            </div>
            <div className='p-field'>
              <label htmlFor='confirmEmail'>
                {t("recoveryPassword.repeatLabelMail")}
              </label>
              <FormikInputText
                name='confirmEmail'
                id='confirmEmail'
                noSpaces
              />
            </div>
            <CustomButton
              loading={loadingResetPassword}
              label={t("recoveryPassword.labelSendMail")}
              className='!tw-bg-primary'
              type='submit'
            />
          </Form>
        </Formik>
      </div>
    </>
  )
}

export default RecoveryPasswordStep1
